/**
 * Imperial CMS — German visitor-facing translations.
 *
 * Mirrors `pl.ts` structure (shape constrained by `MessagesShape` type).
 */

import type { MessagesShape } from "./pl";

export const messagesDe: MessagesShape = {
  maintenance: {
    title: "Einen Moment bitte",
    subtitle: "Wir arbeiten an diesem Bereich",
    body: "Wir sind gleich wieder da. Die Seite wird automatisch aktualisiert.",
    footnote: "Vielen Dank für Ihre Geduld.",
  },

  serviceDisabled: {
    title: "Wartungsarbeiten",
    subtitle: "Dienst derzeit nicht verfügbar",
    body: "Wir bitten um Entschuldigung für die Unannehmlichkeiten. Bitte kommen Sie in Kürze zurück — die Seite wird automatisch aktualisiert.",
    footnote: "Vielen Dank für Ihre Geduld.",
  },

  notFound: {
    title: "Nicht gefunden",
    body: "Die gesuchte Adresse existiert nicht oder wurde verschoben.",
    homeLink: "Zurück zur Startseite",
  },

  loginRequired: {
    title: "Inhalt nach der Anmeldung verfügbar",
    body: "Sie müssen angemeldet sein, um diese Seite zu sehen. Nach der Anmeldung kehren Sie genau hierher zurück.",
    loginButton: "Anmelden",
    homeLink: "Zurück zur Startseite",
  },

  globalLoginGate: {
    title: "Anmeldung erforderlich",
    message: "Sie müssen sich anmelden, um auf die Inhalte dieser Website zuzugreifen.",
    loginLabel: "Login oder E-Mail",
    passwordLabel: "Passwort",
    submit: "Anmelden",
    submitting: "Anmeldung...",
    failed: "Ungültiger Login oder Passwort.",
  },

  homepage: {
    backendErrorTitle: "Backend-Kommunikationsfehler",
    redirectLoopTitle: "Konfigurationsfehler der Startseite",
    redirectLoopMessage:
      "Die Startseite ist aufgrund einer falsch konfigurierten Weiterleitung " +
      "derzeit nicht verfügbar — die angegebene Adresse verweist zurück auf " +
      "die Startseite und erzeugt eine Weiterleitungsschleife.",
    redirectLoopHint: "Bitte wenden Sie sich an den Administrator der Website.",
    bootstrapErrorHint:
      "Die Startseite wurde nicht gerendert, weil das Backend einen Fehler " +
      "zurückgegeben hat. Es gingen keine Inhalte verloren - beheben Sie die " +
      "Ursache oben und laden Sie die Seite neu.",
  },

  backendOutage: {
    maintenanceTitle: "Systemaktualisierung läuft",
    maintenanceBody: "Wir spielen eine neue Version der Website ein. Sie ist in wenigen Minuten wieder da.",
    unavailableTitle: "Dienst vorübergehend nicht verfügbar",
    unavailableBody: "Wir können den Server gerade nicht erreichen. Wir arbeiten daran.",
    maintenanceAction: "Eine Systemaktualisierung läuft. Bitte versuchen Sie es in wenigen Minuten erneut.",
    unavailableAction: "Der Dienst ist vorübergehend nicht verfügbar. Bitte versuchen Sie es gleich erneut.",
    errorTitle: "Etwas ist schiefgelaufen",
    errorBody: "Diese Seite konnte nicht angezeigt werden.",
    autoRefresh: "Die Seite wird automatisch aktualisiert.",
    retry: "Erneut versuchen",
    footnote: "Vielen Dank für Ihre Geduld.",
  },

  common: {
    readDocs: "Dokumentation lesen ->",
    paginationNext: "Weiter ->",
  },
};
